import { render, staticRenderFns } from "./Layout-full.vue?vue&type=template&id=3c5b1f76"
import script from "./Layout-full.vue?vue&type=script&lang=js"
export * from "./Layout-full.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports